import * as React from 'react';
import classnames from 'classnames';

const Label = ({ type , variant ='medium' , className , children ,  })=>/*#__PURE__*/ React.createElement("b", {
        className: classnames('label', `label--${type}`, `label--${variant}`, className)
    }, children)
;
var Label$1 = Label;

export { Label$1 as default };
//# sourceMappingURL=Label.js.map
